/**
 * DO NOT EDIT THIS FILE DIRECTLY
 * RUN "yarn generate-icons" INSTEAD
 * (see "scripts" in package.json)
 **/
const icons = [
  'abacus',
  'abandoned',
  'acorn',
  'add-bag',
  'aid-kit',
  'air-balloon',
  'air-conditioning',
  'airbrush',
  'airplane-landing',
  'airplane-takeoff',
  'airplane',
  'alarm',
  'alien',
  'ambulance',
  'american-express',
  'anchor',
  'announce',
  'apartment',
  'aperture',
  'apple',
  'atom',
  'auto',
  'axis',
  'baby-book',
  'baby-bottle',
  'baby-mobile',
  'baby-monitor',
  'backpack',
  'badge-1',
  'badge-2',
  'badge-3',
  'badge-4',
  'bag-return',
  'bag',
  'bag2',
  'balance-scale',
  'balloon',
  'balloons',
  'bandaid',
  'bandaids',
  'bar',
  'baseball',
  'basket-ball',
  'basket',
  'bathrobe',
  'bathroom',
  'battery-full',
  'beaker',
  'bear',
  'bell',
  'belt',
  'bicycle',
  'binoculars',
  'blazer',
  'blush',
  'bomb',
  'bonfire',
  'boots-2',
  'boots',
  'bowling-ball',
  'bowtie',
  'box-cutter',
  'boxing-glove',
  'bra',
  'brain',
  'bread-slice',
  'bread',
  'breakfast',
  'briefcase',
  'brush-2',
  'brush',
  'bucket-2',
  'bucket',
  'bug',
  'burger',
  'bus',
  'button',
  'cable-car',
  'cake',
  'calculator',
  'caliper',
  'camera-1',
  'camera-2',
  'camera-3',
  'camera-lens',
  'camera',
  'camping',
  'candy-cane',
  'cap',
  'car-rental',
  'car',
  'carabiner',
  'carrot',
  'cart',
  'chainsaw',
  'chart-1',
  'chart-2',
  'check',
  'cheese',
  'chef',
  'cherry',
  'chicken',
  'chisel',
  'clamp-2',
  'clamp',
  'clapperboard',
  'clip',
  'clipboard',
  'close',
  'coat',
  'code',
  'cog',
  'color-picker-2',
  'color-picker-3',
  'color-picker',
  'comb',
  'comment-1',
  'comment-2',
  'compass',
  'concierge',
  'corndog',
  'cost',
  'coupon',
  'credit-card',
  'crib',
  'cricket',
  'croissant',
  'crosshair',
  'cupcake-2',
  'cupcake',
  'delta-credit-card',
  'desktop',
  'diaper',
  'directions',
  'disabled',
  'discover-credit-card',
  'diving',
  'dna',
  'doctor',
  'dollar-currency',
  'donut',
  'drafting-compass',
  'dress',
  'drill-2',
  'drill',
  'dumbbell',
  'earth-quake',
  'earth',
  'egg',
  'electricity-tower',
  'electricity',
  'elevator',
  'ellipsis-1',
  'ellipsis-2',
  'euro-currency',
  'evaluative',
  'exposure',
  'factory',
  'fax',
  'female-user',
  'film-roll',
  'film-strip',
  'filter',
  'fire',
  'fish',
  'fitness-center',
  'flag',
  'flame',
  'flashlight',
  'flooding',
  'floor-plan',
  'for-sale',
  'forklift',
  'free-toiletries',
  'fries',
  'gallery',
  'gamepad',
  'gas',
  'gaslamp',
  'gauge',
  'gavel',
  'geek-hat',
  'ghost',
  'gift',
  'gingerbread-man',
  'glasses-2',
  'glasses',
  'globe',
  'globe2',
  'gloves',
  'golf-ball',
  'gopro',
  'graduation-cap',
  'gurney',
  'hairdryer',
  'hand-truck',
  'hanger',
  'hard-drive',
  'hat',
  'headphones',
  'heating',
  'helicopter',
  'high-heels-2',
  'high-heels',
  'hoodie',
  'hospital-2',
  'hospital',
  'hot-dog',
  'hourglass',
  'ice-cream-2',
  'ice-cream-3',
  'ice-cream',
  'image',
  'infinity',
  'info',
  'ipod',
  'iron',
  'jcb-credit-card',
  'jerry-can',
  'jewelry',
  'joystick',
  'kayak',
  'key',
  'keyboard',
  'keys',
  'lamp',
  'laptop',
  'laundry',
  'led',
  'life-jacket',
  'light-bulb',
  'linens',
  'loading-2',
  'loading',
  'lounge',
  'luggage-2',
  'luggage',
  'lungs',
  'maestro-credit-card',
  'magnet',
  'mail',
  'mannequin',
  'map-2',
  'map',
  'mask',
  'mastercard-card',
  'medal',
  'medical-phone',
  'medical',
  'medicine',
  'memory',
  'microphone',
  'microscope',
  'milk',
  'minibar',
  'mixer',
  'mobile-app',
  'mobile-sync',
  'molecule',
  'mortgage',
  'motorcycle',
  'natural-energy',
  'neutral-face',
  'newspapers',
  'no-smoking',
  'nurse',
  'onesie',
  'orange',
  'orbit',
  'outlet',
  'pacifier',
  'paperplane',
  'parfume',
  'parking',
  'partial',
  'paypal',
  'pear',
  'pencil',
  'pentool',
  'pets',
  'pie',
  'piggy-bank',
  'pill-2',
  'pill',
  'pin-2',
  'pin',
  'ping-pong',
  'pizza',
  'planet',
  'pliers',
  'plug',
  'plus-circle',
  'plus',
  'pocket-knife',
  'pocket-knife2',
  'pointer',
  'polaroid',
  'polygrip',
  'pool-ball',
  'pool',
  'pound-currency',
  'power-off',
  'presentation',
  'processor',
  'projector',
  'pulse',
  'purse',
  'puzzle',
  'question',
  'quiz',
  'quote',
  'radio',
  'radioactive',
  'rattle',
  'recycle-bin',
  'recycle',
  'refreshment',
  'refrigerator',
  'repair',
  'restaurant',
  'ribbon-2',
  'ribbon-3',
  'ribbon',
  'rocket',
  'rocking-horse',
  'rollers',
  'rope',
  'rubber-duck',
  'rugby-ball',
  'ruler',
  'rupee-currency',
  'sad',
  'safe',
  'safety-pin',
  'satellite-channels',
  'sausage',
  'save',
  'saw',
  'scarf',
  'screwdriver',
  'sd-card',
  'search',
  'seashell',
  'secure',
  'security',
  'servers',
  'share',
  'ship',
  'shirt',
  'shovel-2',
  'shovel',
  'show',
  'shower',
  'shuttle-service',
  'shuttlecock',
  'sitemap',
  'skating',
  'ski',
  'slice',
  'slippers',
  'small-battery',
  'smart-watch',
  'smile',
  'smoking',
  'snowboard',
  'soccer-ball',
  'socks',
  'soda',
  'solar-panel',
  'solo-credit-card',
  'soundproof',
  'spa',
  'space-helmet',
  'spade',
  'star',
  'stethoscope',
  'strawberry',
  'stroller',
  'studio-light',
  'sun-deck',
  'support',
  'sustainability',
  'switch',
  'sync',
  'syringe',
  't-shirt',
  'tag',
  'tap',
  'taxi',
  'team',
  'telephone',
  'telescope',
  'tennis-ball',
  'testube',
  'thermometer',
  'thermos',
  'thumbs-down',
  'thumbs-up',
  'thunder',
  'tie',
  'timer',
  'toaster',
  'toilet',
  'tools',
  'tooth',
  'towels',
  'trailer',
  'train',
  'transport',
  'trash-bin',
  'tree',
  'trophy',
  'trousers',
  'trowel',
  'tulip',
  'tv',
  'umbrella',
  'underwear-2',
  'underwear',
  'usb-2',
  'usb-stick',
  'usb',
  'user',
  'users',
  'verified',
  'vespa',
  'video-camera-1',
  'video-camera-2',
  'video-camera-3',
  'video-camera-4',
  'video-card',
  'villa',
  'visa-credit-card',
  'visa-electron',
  'volley-ball',
  'volume',
  'wallet',
  'water-supply',
  'watermill',
  'webcam',
  'wheelbarrow',
  'wifi',
  'wind-turbine',
  'windmill',
  'winter-hat',
  'wrench',
  'yen-currency',
  'zoom-in',
  'zoom-out',
];
export default icons;
